var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.type === "3"
      ? _c(
          "div",
          { staticClass: "icon-search", on: { click: _vm.goSearch } },
          [
            _c("svg-icon", {
              attrs: { "icon-class": "search", className: "search-svg" }
            })
          ],
          1
        )
      : _c(
          "div",
          {
            staticClass: "commonSearch",
            class: { spanColor: _vm.type === "2" ? true : false },
            on: { click: _vm.goSearch }
          },
          [_c("span", [_vm._v(_vm._s(_vm.searchMassage))])]
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }